// import React, { useState, useEffect } from "react";
// import Paper from "@mui/material/Paper";
// // import Box from "@mui/material/Box";
// import { alpha, styled } from "@mui/material/styles";
// import { Button, Fab, TablePagination } from "@mui/material";
// // import TextField from "@mui/material/TextField";
// import FormGroup from "@mui/material/FormGroup";
// import FormControlLabel from "@mui/material/FormControlLabel";
// import FormControl from "@mui/material/FormControl";
// // import Checkbox from '@mui/material/Checkbox';
// import moment from "moment";
// import Select, { SelectChangeEvent } from "@mui/material/Select";
// import InputLabel from "@mui/material/InputLabel";
// import MenuItem from "@mui/material/MenuItem";
// import CloudUploadIcon from "@mui/icons-material/CloudUpload";
// import { InputAdornment, IconButton } from "@mui/material";
// // import { Typography, Stack } from '@mui/material';
// import createInstance from "../../../api/axiosinstance";
// import Toast from "../../../utils/toast";
// import { Box, Typography, Autocomplete, TextField, Chip } from "@mui/material";
// import "./index.css";
// // import COLORS from "../../Themes/Colours";
// import { useThemeMode } from "../../Themes/ThemeContextTemp.js";
// import LinearProgress from "@mui/material/LinearProgress";

// const Item = styled(Paper)(({ theme }) => ({
//   backgroundColor: theme.palette.mode === "dark" ? " #1A2027" : "#fff",
//   ...theme.typography.body2,
//   padding: theme.spacing(1),
//   textAlign: "center",
//   color: theme.palette.text.secondary,
// }));

// const AddNewCandidate = () => {
//   const { COLORS } = useThemeMode();
//   const [name, setName] = useState("");
//   const [selectedJobID, setSelectedJobID] = useState("");
//   const [selectedJobDetails, setSelectedJobDetails] = useState({});
//   const [selectedSkills, setSelectedSkills] = useState([]);
//   const aiDishaApi = createInstance("DISHA");
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(5);
//   const [educationDetails, setEducationDetails] = useState([]);
//   const [educationDetailsUg, setEducationDetailsUg] = useState([]);
//   const [educationDetailsPg, setEducationDetailsPg] = useState([]);
//   const [yearsOfExpList, setYearsOfExpList] = useState([]);
//   const [monthsOfExpList, setMonthsOfExpList] = useState([]);
//   const [expYearsList, setExpYearsList] = useState([]);
//   const [selectedYear, setSelectedYear] = useState("");
//   const [selectedMonth, setSelectedMonth] = useState("");
//   const [candidate_full_name, setCandidate_full_name] = useState();
//   const [email_id, setEmail_id] = useState("");
//   const [skills, setSkills] = useState("");
//   const [loading, setLoading] = useState("");
//   const [ugDegree, setUgDegree] = useState("");
//   const [pgDegree, setPgDegree] = useState("");
//   const [isOthersUg, setIsOthersUg] = useState(false);
//   const [isOthersPg, setIsOthersPg] = useState(false);
//   const [jobIDs, setJobIDs] = useState([]);
//   const [alljobs, setAllJobs] = useState([]);
//   const [jobTitle, setJobTitle] = useState([]);
//   const [jobDescription, setJobDescription] = useState(""); // Added job description state
//   const [years, setYears] = useState([]);
//   const [resume, setResume] = useState(null);
//   const [error, setError] = useState("");
//   const [ActiveSkills, setActiveSkills] = useState([]);
//   const [requiredSkills, setRequiredSkills] = useState([]);
//   const organizationId = window.sessionStorage.getItem("organizationId");
//   const [resumeFile, setResumeFile] = useState(null);
//   const [uploadProgress, setUploadProgress] = useState(0);

//   useEffect(() => {
//     getYearsOfExpList();
//     getMonthsOfExpList();
//     getActiveSkills();
//     getUgDetails();
//     getPgDetails();
//     fetchAllJobs();
//     fetchActiveJobs();
//   }, []);

//   const handleFormSubmit = async (event) => {
//     event.preventDefault();
//     try {
//       if (!selectedJobID || !selectedJobID.trim()) {
//         console.error("JobID cannot be empty");
//         Toast.error("JobID cannot be empty");
//         return;
//       }
//       if (!candidate_full_name.trim()) {
//         console.error("Candidate name cannot be empty");
//         Toast.error("Candidate name cannot be empty");
//         return;
//       }

//       if (!email_id.trim()) {
//         console.error("Email cannot be empty");
//         Toast.error("Email cannot be empty");
//         return;
//       }

//       if (requiredSkills.length === 0) {
//         console.error("Skills cannot be empty");
//         Toast.error("Skills cannot be empty");
//         return;
//       }
//       if (!selectedYear.trim()) {
//         console.error("Experience of years cannot be empty");
//         Toast.error("Experience of years cannot be empty");
//         return;
//       }
//       if (!selectedMonth.trim()) {
//         console.error("Experience of months cannot be empty");
//         Toast.error("Experience of months cannot be empty");
//         return;
//       }
//       if (!resume) {
//         console.error("Resume cannot be empty");
//         Toast.error("Resume cannot be empty");
//         return;
//       }

//       console.log(
//         "Data is added",
//         candidate_full_name,
//         email_id,
//         requiredSkills,
//         selectedYear,
//         selectedMonth,
//         resume,
//         educationDetails
//       );

//       // Prepare form data for submission
//       const formData = new FormData();
//       formData.append("organization_id", organizationId);
//       formData.append("job_id", selectedJobID);
//       formData.append("candidate_full_name", candidate_full_name);
//       formData.append("email_id", email_id);
//       formData.append("skills", requiredSkills);
//       formData.append("experience_years", selectedYear);
//       formData.append("experience_months", selectedMonth);
//       formData.append("upload_resume", resume);
//       formData.append("educational_qualification", educationDetails);
//       formData.append("job_description", jobDescription);

//       // Log form data
//       const formDataObject = {};
//       formData.forEach((value, key) => {
//         setLoading(true);
//         formDataObject[key] = value;
//       });

//       const response = await aiDishaApi.post("/add-candidate/", formData, {
//         headers: {
//           "Content-Type": "multipart/form-data",
//         },
//       });

//       console.log("Response:", response);
//       if (response.status === 200) {
//         Toast.success("Added successfully");
//         handleClear();
//       }
//     } catch (error) {
//       console.error("Error:", error);
//       if (error.response) {
//         console.error("Response data:", error.response.data);
//         Toast.error(
//           error.response.data.detail || "An unexpected error occurred"
//         );
//       } else {
//         Toast.error("An unexpected error occurred");
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   // To get all 'active' skills from Skill table
//   const getActiveSkills = async () => {
//     await aiDishaApi
//       .get("/skills-show/active")
//       .then((response) => {
//         const skillData = response.data;
//         setActiveSkills(skillData);
//         console.log("checking skills values :", skillData);
//         const skillNames = skillData.map((skill) => skill.skill_name);
//         console.log("All Skill Names:", skillNames);
//       })
//       .catch((error) => {
//         console.error("Error fetching active skills" + error);
//       });
//   };

//   const fetchAllJobs = async () => {
//     try {
//       const response = await aiDishaApi.get(
//         `/all_active_jobs?org_id=${organizationId}`
//       );
//       const jobs = response.data;

//       if (Array.isArray(jobs)) {
//         setAllJobs(jobs);
//         console.log("All Jobs: ", jobs);
//       } else {
//         console.warn("Expected an array but received: ", jobs);
//         setAllJobs([]);
//       }
//     } catch (error) {
//       console.error("Error fetching all jobs: ", error);
//       setAllJobs([]);
//     }
//   };

//   const fetchActiveJobs = async (jobID) => {
//     setSelectedJobID(jobID);

//     try {
//       const response = await aiDishaApi.get(
//         `/get_jobdetail_by_job_id?job_id=${jobID}`
//       );
//       const jobData = response.data;
//       console.log("Job data fetched:", jobData);

//       if (jobData) {
//         // Set job title
//         if (jobData.job_title) {
//           setJobTitle(jobData.job_title);
//           console.log(`Job Title for ${jobID}: ${jobData.job_title}`);
//         } else {
//           setJobTitle("");
//           console.warn(`No job title found for Job ID: ${jobID}`);
//         }

//         // Set job description
//         if (jobData.job_description) {
//           setJobDescription(jobData.job_description);
//           console.log(
//             `Job Description for ${jobID}: ${jobData.job_description}`
//           );
//         } else {
//           setJobDescription("");
//           console.warn(`No job description found for Job ID: ${jobID}`);
//         }
//       } else {
//         setJobTitle("");
//         setJobDescription("");
//         console.warn(`No job found for Job ID: ${jobID}`);
//       }
//     } catch (error) {
//       console.error(`Error fetching data for Job ID: ${jobID}`, error);
//       setJobTitle("");
//       setJobDescription("");
//     }
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   const handleFileChange = (e) => {
//   const file = e.target.files[0];

//   if (!file) return;

//   const maxSize = 5 * 1024 * 1024; // 5MB

//   if (file.size > maxSize) {
//     alert("File size must be less than 5 MB");
//     return;
//   }

//   setResumeFile(file);
// };



//   const removeFile = () => {
//   setResumeFile(null);
// };

//   // const handleFileChange = (event) => {
//   //   const file = event.target.files[0];
//   //   if (file) {
//   //     setResume(file);
//   //   } else {
//   //     setResume(null);
//   //   }
//   // };

//   const handleClear = () => {
//     setSelectedJobDetails("");
//     setCandidate_full_name("");
//     setSelectedJobID("");
//     setEmail_id("");
//     setEduDetails([]);
//     setJobTitle("");
//     setJobDescription(""); // Clear job description
//     setRequiredSkills([]);
//     setSelectedYear("");
//     setSelectedMonth("");
//   };

//   const currentDate = moment().format("MM/DD/YYYY");

//   const getYearsOfExpList = async () => {
//     setYearsOfExpList([
//       "0",
//       "1",
//       "2",
//       "3",
//       "4",
//       "5",
//       "6",
//       "7",
//       "8",
//       "9",
//       "10",
//       "11",
//       "12",
//       "13",
//       "14",
//       "15",
//       "16",
//       "17",
//       "18",
//       "19",
//       "20",
//       "21",
//       "22",
//       "23",
//       "24",
//       "25",
//       "26",
//       "27",
//       "28",
//       "29",
//       "30",
//       "31",
//       "32",
//       "33",
//       "34",
//       "35",
//       "36",
//       "37",
//       "38",
//       "39",
//       "40",
//     ]);
//   };

//   const getMonthsOfExpList = async () => {
//     setMonthsOfExpList([
//       "0",
//       "1",
//       "2",
//       "3",
//       "4",
//       "5",
//       "6",
//       "7",
//       "8",
//       "9",
//       "10",
//       "11",
//       "12",
//     ]);
//   };

//   const getUgDetails = async () => {
//     await aiDishaApi
//       .get("/undergraduate_degrees")
//       .then((response) => {
//         setEducationDetailsUg(response.data);
//         console.log(response.data);
//       })
//       .catch((error) => {
//         console.error("Error fetching UG details" + error);
//       });
//   };

//   const getPgDetails = async () => {
//     await aiDishaApi
//       .get("/postgraduate_degrees")
//       .then((response) => {
//         setEducationDetailsPg(response.data);
//         console.log(response.data);
//       })
//       .catch((error) => {
//         console.error("Error fetching PG details" + error);
//       });
//   };

//   const validateEdu = (event) => {};

//   const setEduDetails = (event) => {
//     console.log(event);
//     setEducationDetails(event);

//     for (var i = 0; i < event?.length; i++) {
//       setIsOthersUg(event[i] == "Others(UG)" ? true : false);
//       if (isOthersUg) {
//         break;
//       }
//     }
//     for (var i = 0; i < event?.length; i++) {
//       setIsOthersUg(event[i] == "Others(UG)" ? true : false);
//       if (isOthersUg) {
//         break;
//       }
//     }
//     for (var i = 0; i < event?.length; i++) {
//       setIsOthersPg(event[i] == "Others(PG)" ? true : false);
//       if (isOthersPg) {
//         break;
//       }
//     }
//     for (var i = 0; i < event?.length; i++) {
//       setIsOthersPg(event[i] == "Others(PG)" ? true : false);
//       if (isOthersPg) {
//         break;
//       }
//     }
//     console.log("UG others ? " + isOthersUg);
//     console.log("PG others ? " + isOthersPg);
//   };


//   const handleSubmit = async (e) => {
//   e.preventDefault();

//   setLoading(true);
//   setUploadProgress(0);

//   const interval = setInterval(() => {
//     setUploadProgress((prev) => {
//       if (prev >= 100) {
//         clearInterval(interval);
//         setLoading(false);
//         return 100;
//       }
//       return prev + 10;
//     });
//   }, 300);
// };

//   const CssTextField = styled(TextField)({
//     "& .MuiPaper-root": {
//       backgroundColor: "#033538",
//     },
//     "& .MuiMenuItem-root": {
//       color: "white",
//     },
//   });

//   const CssFormControl = styled(FormControl)({
//     "& label": {
//       color: "black",
//       "&.Mui-focused": {
//         color: "black",
//       },
//     },
//     "& .MuiInputBase-root": {
//       color: "black",
//       "& .MuiOutlinedInput-notchedOutline": {
//         borderColor: "#B9B9B9",
//         borderRadius: 10,
//       },
//       "&:hover .MuiOutlinedInput-notchedOutline": {
//         borderColor: "#B9B9B9",
//       },
//       "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
//         borderColor: "#B9B9B9",
//       },
//     },
//   });

//   const CssSelect = styled(Select)({
//     "& .MuiSvgIcon-root": {
//       color: "black",
//       textAlign: "center",
//     },
//   });

//   return (
//     <div
//       style={{
//         height: "calc(100% - 6%)",
//         overflow: "scroll",
//         overflowX: "hidden",
//         scrollbarWidth: "thin",
//         msOverflowStyle: "none",
//         scrollbarColor: "transparent transparent",
//         "&::-webkit-scrollbar": {
//           width: "5px",
//           height: "5px",
//         },
//       }}
//     >
//       <form onSubmit={handleFormSubmit}>
//         <Box
//           display="grid"
//           gridTemplateColumns="repeat(12, 1fr)"
//           sx={{
//             marginTop: "auto",
//             alignItems: "center",
//             borderRadius: "10px",
//             padding: "1% 10%",
//           }}
//         >
//           <Box
//             gridColumn="span 12"
//             sx={{ marginTop: "auto", textAlign: "left", marginBottom: "3%" }}
//           >
//             <Typography
//               sx={{ fontFamily: "poppins", fontSize: "28px", color: COLORS.text }}
//             >
//               Add Candidate
//             </Typography>
//           </Box>

//           <Box
//             gridColumn="span 6"
//             sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
//           >
//             <Typography sx={{ fontFamily: "poppins", color: COLORS.text }}>
//               Job ID<span style={{ color: "red" }}>*</span>
//             </Typography>
//             <CssTextField
//               select
//               displayEmpty
//               value={selectedJobID}
//               onChange={(e) => fetchActiveJobs(e.target.value)}
//               size="small"
//               required
//               disabled={false}
//               sx={{ width: "95%", 
//                 color: COLORS.text, 
//                 background: COLORS.primary,
//                 "& .MuiSelect-select": {
//                   color: selectedJobID ? COLORS.text : "#888888"
//                 }
                
//                }}
//             >
//               <MenuItem
//                 value=""
//                 disabled
//                 sx={{
//                   color: COLORS.text,
//                   background: "white",
//                   "&.Mui-disabled": {
//                     color: COLORS.text,
//                     opacity: 1,
//                   },
//                 }}
//               >
//                 Select Job ID
//               </MenuItem>

//               {alljobs.map((job) => (
//                 <MenuItem
//                   key={job.Job_ID}
//                   value={job.Job_ID}
//                   sx={{
//                     color: COLORS.text,
//                     background: "white",

//                     "&:hover": {
//                       background:COLORS.border,
//                     },

//                     "&.Mui-selected": {
//                       background: COLORS.border,
//                       color: COLORS.text,
//                     },

//                     "&.Mui-selected:hover": {
//                       background: COLORS.border,
//                     },
//                   }}
//                 >
//                   {job.Job_ID}
//                 </MenuItem>
//               ))}
//             </CssTextField>
//           </Box>

//           <Box
//             gridColumn="span 6"
//             sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
//           >
//             <Typography sx={{ fontFamily: "poppins", color: COLORS.text }}>
//               Job Title
//             </Typography>

//             <CssTextField
//               disabled
//               placeholder="Job Title"
//               value={jobTitle}
//               size="small"
//               sx={{
//                 width: "95%",
//                 background: COLORS.primary,

//                 /* ✅ Disabled input text */
//                 "& .MuiInputBase-input.Mui-disabled": {
//                   color: COLORS.text,
//                   WebkitTextFillColor: COLORS.text,
//                   opacity: 1,
//                 },

//                 /* ✅ Disabled outline */
//                 "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline":
//                   {
//                     borderColor: COLORS.border,
//                   },
//               }}
//               InputLabelProps={{
//                 sx: {
//                   color: COLORS.text,
//                   "&.Mui-disabled": {
//                     color: COLORS.text,
//                   },
//                 },
//               }}
//             />
//           </Box>

//           {/* New Job Description Field */}
//           <Box
//             gridColumn="span 12"
//             sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
//           >
//             <Typography sx={{ fontFamily: "poppins", color: COLORS.text }}>
//               Job Description
//             </Typography>
//             <CssTextField
//               disabled
//               value={jobDescription}
//               size="small"
//               multiline
//               rows={4}
//               sx={{
//                 width: "97.5%",
//                 background: COLORS.primary,

//                 /* ✅ Disabled text color */
//                 "& .MuiInputBase-input.Mui-disabled": {
//                   color: COLORS.text, // dark text
//                   WebkitTextFillColor: COLORS.text, // REQUIRED for Chrome
//                   opacity: 1, // remove faded look
//                 },

//                 /* ✅ Disabled outline */
//                 "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline":
//                   {
//                     borderColor: COLORS.border,
//                   },
//               }}
//               InputLabelProps={{
//                 sx: {
//                   color: COLORS.text,
//                   "&.Mui-disabled": {
//                     color: COLORS.text,
//                   },
//                 },
//               }}
//             />
//           </Box>

//           <Box
//             gridColumn="span 6"
//             sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
//           >
//             <Typography sx={{ fontFamily: "poppins", color: COLORS.text }}>
//               Candidate_fullname<span style={{ color: "red" }}>*</span>
//             </Typography>
//             <TextField
//               size="small"
//               id="custom-css-outlined-input"
//               variant="outlined"
//               value={candidate_full_name}
//               onChange={(e) => setCandidate_full_name(e.target.value)}
//               sx={{
//                 width: "95%",
//                 borderRadius: "10px",
//                 background: COLORS.primary,
//                 "& .MuiOutlinedInput-notchedOutline": {
//                   borderColor: COLORS.border,
//                   borderRadius: "10px",
//                 },
//                 "&.MuiOutlinedInput-root.Mui-focused.MuiOutlinedInput-notchedOutline":
//                   {
//                     borderColor: COLORS.border,
//                     color: COLORS.text,
//                   },
//                 "& .MuiInputLabel-root": {
//                   color: COLORS.text,
//                 },
//                 "& .MuiInputLabel-root.Mui-focused": {
//                   color: COLORS.text,
//                 },
//                 "& .MuiInputBase-input": {
//                   color: COLORS.text,
//                 },
//               }}
//               required
//             />
//           </Box>

//           <Box
//             gridColumn="span 6"
//             sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
//           >
//             <Typography sx={{ fontFamily: "poppins", color: COLORS.text }}>
//               Email<span style={{ color: "red" }}>*</span>
//             </Typography>
//             <TextField
//               size="small"
//               id="custom-css-outlined-input"
//               variant="outlined"
//               value={email_id}
//               onChange={(e) => setEmail_id(e.target.value)}
//               sx={{
//                 width: "95%",
//                 background: COLORS.primary,
//                 "& .MuiOutlinedInput-notchedOutline": {
//                   borderColor: COLORS.border,
//                   borderRadius: "10px",
//                 },
//                 "&.MuiOutlinedInput-root.Mui-focused.MuiOutlinedInput-notchedOutline":
//                   {
//                     borderColor: COLORS.border,
//                   },
//                 "& .MuiInputLabel-root": {
//                   color: COLORS.text,
//                 },
//                 "& .MuiInputLabel-root.Mui-focused": {
//                   color: COLORS.text,
//                 },
//                 "& .MuiInputBase-input": {
//                   color: COLORS.text,
//                 },
//               }}
//               required
//             />
//           </Box>

//           <Box
//             gridColumn="span 6"
//             sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
//           >
//             <Typography
//               sx={{
//                 fontFamily: "poppins",
//                 color: COLORS.text,
//                 textAlign: "left",
//               }}
//             >
//               Skills
//               <span style={{ color: "red" }}>*</span>
//             </Typography>
//             <CssFormControl sx={{ width: "90%",
//                                   background: COLORS.primary, 
//                                   borderRadius: "10px",
//                                   "& .MuiInputLabel-root": {
//                                      color: COLORS.text
//                                    },
//                                    "& .MuiInputLabel-root.Mui-focused": {
//                                      color: COLORS.text
//                                    } }}>
//               <InputLabel>Select Skills</InputLabel>
//               <CssSelect
//                 multiple
//                 label="Select skills"
//                 id="demo-simple-select-outlined"
//                 size="small"
//                 sx={{ width: "100%", 
//                   textAlign: "center", 
//                   mb: "2%",
//                   borderRadius: "10px",
//                   borderColor: COLORS.border,
//                 "& .MuiInputBase-input": {
//                   color: COLORS.text,
//                 }, }}
//                 value={requiredSkills}
//                 onChange={(e) => setRequiredSkills(e.target.value)}
//               >
//                 {(ActiveSkills || []).map((skill) => (
//                   <MenuItem
//                     key={skill.skill_id}
//                     value={skill.skill_name.trim()}
//                     sx={{ color: COLORS.text, backgroundColor: "white" }}
//                   >
//                     {skill.skill_name.trim()}
//                   </MenuItem>
//                 ))}
//               </CssSelect>
//             </CssFormControl>
//           </Box>

//           <Box
//             gridColumn="span 6"
//             sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
//           >
//             <Typography
//               sx={{
//                 fontFamily: "poppins",
//                 color:COLORS.text,
//                 textAlign: "left",
//               }}
//             >
//               Experience(in Years)<span style={{ color: "red" }}>*</span>
//             </Typography>
//             <CssFormControl sx={{ width: "40%",
//                                  background: COLORS.primary, 
//                                  borderRadius: "10px",
//                                  "& .MuiInputBase-input": {
//                                   color: COLORS.text,
//                                 }, 
//                                 "& .MuiInputLabel-root": {
//                                    color: COLORS.text
//                                  },
//                                  "& .MuiInputLabel-root.Mui-focused": {
//                                    color: COLORS.text
//                                  }}}>
//               <InputLabel>Select Years</InputLabel>
//               <CssSelect
//                 label="Experience"
//                 id="demo-simple-select-outlined"
//                 size="small"
//                 value={selectedYear}
//                 onChange={(e) => setSelectedYear(e.target.value)}
//                 sx={{ width: "100%", textAlign: "center" }}
//                 required={true}
//                 disabled={false}
//               >
//                 {yearsOfExpList.map((exp) => (
//                   <MenuItem
//                     key={exp}
//                     value={exp}
//                     sx={{ color: COLORS.text, background: "white" }}
//                   >
//                     {exp}
//                   </MenuItem>
//                 ))}
//               </CssSelect>
//             </CssFormControl>
//             <CssFormControl sx={{ width: "40%", 
//                                   ml: "5%" ,
//                                   background: COLORS.primary, 
//                                   borderRadius: "10px",
//                                   "& .MuiInputBase-input": {
//                                     color: COLORS.text,
//                                   }, 
//                                   "& .MuiInputLabel-root": {
//                                      color: COLORS.text
//                                    },
//                                    "& .MuiInputLabel-root.Mui-focused": {
//                                      color: COLORS.text
//                                    }}}>
//               <InputLabel>Select Months</InputLabel>
//               <CssSelect
//                 label="Experience"
//                 id="demo-simple-select-outlined"
//                 size="small"
//                 value={selectedMonth}
//                 onChange={(e) => setSelectedMonth(e.target.value)}
//                 sx={{ width: "100%", textAlign: "center" }}
//                 required={true}
//                 disabled={false}
//               >
//                 {monthsOfExpList.map((exp) => (
//                   <MenuItem
//                     key={exp}
//                     value={exp}
//                     sx={{ color: COLORS.text, backgroundColor: "white" }}
//                   >
//                     {exp}
//                   </MenuItem>
//                 ))}
//               </CssSelect>
//             </CssFormControl>
//           </Box>

//           <Box
//             gridColumn="span 6"
//             sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%", }}
//           >
//             <Typography
//               sx={{
//                 fontFamily: "poppins",
//                 color: COLORS.text,
//                 textAlign: "left",
//               }}
//             >
//               Education<span style={{ color: "red" }}>*</span>
//             </Typography>
//             <CssFormControl sx={{ width: "90%",
//               background:COLORS.primary, 
//               borderRadius:"10px",
//                "& .MuiInputLabel-root": {
//                  color: COLORS.text
//                },
//                "& .MuiInputLabel-root.Mui-focused": {
//                  color: COLORS.text
//                } }}>
//               <InputLabel>Select Education Details</InputLabel>
//               <CssSelect
//                 multiple={true}
//                 label="Select education details"
//                 id="demo-simple-select-outlined"
//                 size="small"
//                 required
//                 sx={{ width: "100%", 
//                    textAlign: "center", 
//                    mb: "2%",
//                   "& .MuiInputBase-input": {
//                   color: COLORS.text,
//                 },
          
//                 }}
//                 value={educationDetails}
//                 onChange={(e) => setEduDetails(e.target.value)}
//               >
//                 <MenuItem
//                   key="ug"
//                   value="ug"
//                   disabled={true}
//                   sx={{ color: "#B9B9B9", backgroundColor: "black" }}
//                 >
//                   Under Graduate
//                 </MenuItem>
//                 {educationDetailsUg.map((degreeUg) => (
//                   <MenuItem
//                     key={degreeUg}
//                     value={degreeUg}
//                     sx={{ color: COLORS.text, backgroundColor: "white" }}
//                   >
//                     {degreeUg}
//                   </MenuItem>
//                 ))}
//                 <MenuItem
//                   key="pg"
//                   value="pg"
//                   disabled={true}
//                   sx={{ color: "#B9B9B9", backgroundColor: "black" }}
//                 >
//                   Post Graduate
//                 </MenuItem>
//                 {educationDetailsPg.map((degreePg) => (
//                   <MenuItem
//                     key={degreePg}
//                     value={degreePg}
//                     sx={{ color: COLORS.text, backgroundColor: "white" }}
//                   >
//                     {degreePg}
//                   </MenuItem>
//                 ))}
//               </CssSelect>
//             </CssFormControl>
//           </Box>

//           <Box
//             gridColumn="span 6"
//             sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
//             display={isOthersUg == true ? "block" : "none"}
//           >
//             <Typography
//               sx={{
//                 fontFamily: "poppins",
//                 color: "#033538",
//                 textAlign: "left",
//               }}
//             >
//               Educational Details (UG)
//             </Typography>
//             <CssTextField
//               label="Enter UG Educational Details"
//               id="custom-css-outlined-input"
//               size="small"
//               sx={{ width: "90%", mb: "2%" }}
//               value={ugDegree}
//               onChange={(e) => setUgDegree(e.target.value)}
//             />
//           </Box>

//           <Box
//             gridColumn="span 6"
//             sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
//             display={isOthersPg == true ? "block" : "none"}
//           >
//             <Typography
//               sx={{
//                 fontFamily: "poppins",
//                 color: "#033538",
//                 textAlign: "left",
//               }}
//             >
//               Educational Details (PG)
//             </Typography>
//             <CssTextField
//               label="Enter PG Educational Details"
//               id="custom-css-outlined-input"
//               size="small"
//               sx={{ width: "90%", mb: "2%" }}
//               value={pgDegree}
//               onChange={(e) => setPgDegree(e.target.value)}
//             />
//           </Box>

//           {/* <Box
//             gridColumn="span 6"
//             sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
//           >
//             <label
//               htmlFor="formFile"
//               className="form-label"
//               style={{ color: COLORS.text }}
//             >
//               Upload Resume<span style={{ color: "red" }}>*</span>
//             </label>
//             <input
//               className="form-control"
//               type="file"
//               id="formFile"
//               style={{ width: "95%" }}
//               accept=".pdf,.doc,.docx"
//               onChange={(e) => handleFileChange(e)}
//               required
//             />
//           </Box> */}

// <Box
//   gridColumn="span 6"
//   sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
// >
//   <label
//     htmlFor="formFile"
//     className="form-label"
//     style={{ color: COLORS.text }}
//   >
//     Upload Resume <span style={{ color: "red" }}>*</span>
//   </label>

//   <input
//     className="form-control"
//     type="file"
//     id="formFile"
//     style={{ width: "95%" }}
//     accept=".pdf,.doc,.docx"
//     onChange={handleFileChange}
//   />

//   {/* File size info */}
//   <Typography sx={{ fontSize: "12px", color: "#888", mt: 1 }}>
//     Maximum file size: 5 MB
//   </Typography>

//   {/* Uploaded file info */}
//   {resumeFile && (
//     <Box
//       sx={{
//         mt: 1,
//         p: 1,
//         width: "95%",
//         border: "1px solid #ddd",
//         borderRadius: "6px",
//         display: "flex",
//         justifyContent: "space-between",
//         alignItems: "center",
//       }}
//     >
//       <Typography sx={{ color: COLORS.text, fontSize: "14px" }}>
//         {resumeFile.name} ({(resumeFile.size / 1024 / 1024).toFixed(2)} MB)
//       </Typography>

//       <Button
//         size="small"
//         color="error"
//         onClick={removeFile}
//       >
//         Remove
//       </Button>
//     </Box>
//   )}
// </Box>


//           <Box
//             gridColumn="span 8"
//             sx={{ marginTop: "8%", ml: "35%", textAlign: "center" }}
//           >
//             <Button
//               onClick={handleClear}
//               sx={{
//                 border: "1px solid",
//                 color: COLORS.button,
//                 width: "120px",
//                 height: "40px",
//                 borderRadius: "10px",
//                 fontFamily: "poppins",
//               }}
//             >
//               Reset
//             </Button>
//             <Button
//               type="submit"
//               variant="contained"
//               disabled={loading}
//               sx={{
//                 ml: "2%",
//                 // border: "1px solid",
//                 color: COLORS.button,
//                 background:COLORS.button_green_bg,
//                 ":hover":{
//                  background: COLORS.hover_green_btn
//                 },
//                 width: "120px",
//                 height: "40px",
//                 borderRadius: "10px",
//                 fontFamily: "poppins",
//               }}
//             >
//               {loading ? `Uploading ${uploadProgress}%` : "Submit"}
//             </Button>
//             {loading && (
//   <Box sx={{ width: "95%", mt: 2 }}>
//     <Typography sx={{ fontSize: "14px", color: COLORS.text }}>
//       Uploading resume... Please don't refresh or change tabs.
//     </Typography>

//     <LinearProgress
//       variant="determinate"
//       value={uploadProgress}
//       sx={{
//         height: "10px",
//         borderRadius: "10px",
//         mt: 1,
//       }}
//     />

//     <Typography sx={{ fontSize: "12px", mt: 1 }}>
//       {uploadProgress}% completed
//     </Typography>
//   </Box>
// )}
//           </Box>
//         </Box>
//       </form>
//     </div>
//   );
// };

// export default AddNewCandidate;
































import React, { useState, useEffect } from "react";
import Paper from "@mui/material/Paper";
import { alpha, styled } from "@mui/material/styles";
import { Button, Fab, TablePagination } from "@mui/material";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import moment from "moment";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { InputAdornment, IconButton } from "@mui/material";
import createInstance from "../../../api/axiosinstance";
import Toast from "../../../utils/toast";
import { Box, Typography, Autocomplete, TextField, Chip } from "@mui/material";
import "./index.css";
import { useThemeMode } from "../../Themes/ThemeContextTemp.js";
import LinearProgress from "@mui/material/LinearProgress";
import WarningIcon from "@mui/icons-material/Warning";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? " #1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

// Enhanced Loading Overlay Component
const UploadOverlay = ({ isVisible, progress, resumeFile }) => {
  return (
    <Box
      sx={{
        display: isVisible ? "flex" : "none",
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.7)",
        backdropFilter: "blur(5px)",
        zIndex: 9999,
        justifyContent: "center",
        alignItems: "center",
        animation: isVisible ? "fadeIn 0.3s ease-in" : "none",
        "@keyframes fadeIn": {
          from: { opacity: 0 },
          to: { opacity: 1 },
        },
      }}
    >
      <Box
        sx={{
          backgroundColor: "white",
          borderRadius: "16px",
          padding: "48px 40px",
          textAlign: "center",
          maxWidth: "500px",
          width: "90%",
          boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
          animation: "slideUp 0.4s ease-out",
          "@keyframes slideUp": {
            from: { transform: "translateY(30px)", opacity: 0 },
            to: { transform: "translateY(0)", opacity: 1 },
          },
        }}
      >
        {/* Upload Icon Animation */}
        <Box
          sx={{
            width: "80px",
            height: "80px",
            margin: "0 auto 24px",
            backgroundColor: "#f0f7ff",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            animation: "pulse 2s ease-in-out infinite",
            "@keyframes pulse": {
              "0%": { transform: "scale(1)", boxShadow: "0 0 0 0 rgba(33, 150, 243, 0.7)" },
              "50%": { transform: "scale(1.05)", boxShadow: "0 0 0 10px rgba(33, 150, 243, 0)" },
              "100%": { transform: "scale(1)", boxShadow: "0 0 0 0 rgba(33, 150, 243, 0)" },
            },
          }}
        >
          <CloudUploadIcon sx={{ fontSize: "48px", color: "#2196f3" }} />
        </Box>

        {/* Main Text */}
        <Typography
          sx={{
            fontSize: "24px",
            fontWeight: "600",
            color: "#1a1a1a",
            marginBottom: "8px",
            fontFamily: "poppins",
          }}
        >
          Adding Candidate...
        </Typography>

        {/* File Name */}
        {resumeFile && (
          <Typography
            sx={{
              fontSize: "14px",
              color: "#666",
              marginBottom: "24px",
              wordBreak: "break-word",
              fontFamily: "poppins",
            }}
          >
            {resumeFile.name}
          </Typography>
        )}

        {/* Progress Bar */}
        <Box sx={{ marginBottom: "24px" }}>
          <Box
            sx={{
              width: "100%",
              height: "8px",
              backgroundColor: "#e0e0e0",
              borderRadius: "10px",
              overflow: "hidden",
              marginBottom: "12px",
              boxShadow: "inset 0 2px 4px rgba(0, 0, 0, 0.1)",
            }}
          >
            <Box
              sx={{
                height: "100%",
                width: `${progress}%`,
                backgroundColor: progress === 100 ? "#4caf50" : "#2196f3",
                transition: "width 0.3s ease, background-color 0.3s ease",
                borderRadius: "10px",
                boxShadow: progress === 100 ? "0 0 10px #4caf50" : "0 0 10px #2196f3",
              }}
            />
          </Box>
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: "600",
              color: progress === 100 ? "#4caf50" : "#2196f3",
              fontFamily: "poppins",
            }}
          >
            {progress}%
          </Typography>
        </Box>

        {/* Completion Status */}
        {progress === 100 && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              marginBottom: "20px",
              animation: "slideDown 0.4s ease-out",
              "@keyframes slideDown": {
                from: { opacity: 0, transform: "translateY(-10px)" },
                to: { opacity: 1, transform: "translateY(0)" },
              },
            }}
          >
            <CheckCircleIcon sx={{ fontSize: "24px", color: "#4caf50" }} />
            <Typography sx={{ color: "#4caf50", fontWeight: "600", fontFamily: "poppins" }}>
              Upload Complete!
            </Typography>
          </Box>
        )}

        {/* Warning Message */}
        <Box
          sx={{
            backgroundColor: "#fff3cd",
            border: "1px solid #ffc107",
            borderRadius: "8px",
            padding: "12px 16px",
            display: "flex",
            gap: "10px",
            alignItems: "flex-start",
          }}
        >
          <WarningIcon
            sx={{
              fontSize: "20px",
              color: "#ff9800",
              marginTop: "2px",
              flexShrink: 0,
            }}
          />
          <Box>
            <Typography
              sx={{
                fontSize: "13px",
                color: "#856404",
                fontWeight: "600",
                marginBottom: "4px",
                fontFamily: "poppins",
              }}
            >
              Important
            </Typography>
            <Typography
              sx={{
                fontSize: "12px",
                color: "#856404",
                lineHeight: "1.4",
                fontFamily: "poppins",
              }}
            >
              Please don't close the browser, change tabs, or press the back button until the upload is complete. This will interrupt the process.
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

const AddNewCandidate = () => {
  const { COLORS } = useThemeMode();
  const [name, setName] = useState("");
  const [selectedJobID, setSelectedJobID] = useState("");
  const [selectedJobDetails, setSelectedJobDetails] = useState({});
  const [selectedSkills, setSelectedSkills] = useState([]);
  const aiDishaApi = createInstance("DISHA");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [educationDetails, setEducationDetails] = useState([]);
  const [educationDetailsUg, setEducationDetailsUg] = useState([]);
  const [educationDetailsPg, setEducationDetailsPg] = useState([]);
  const [yearsOfExpList, setYearsOfExpList] = useState([]);
  const [monthsOfExpList, setMonthsOfExpList] = useState([]);
  const [expYearsList, setExpYearsList] = useState([]);
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("");
  const [candidate_full_name, setCandidate_full_name] = useState();
  const [email_id, setEmail_id] = useState("");
  const [skills, setSkills] = useState("");
  const [loading, setLoading] = useState("");
  const [ugDegree, setUgDegree] = useState("");
  const [pgDegree, setPgDegree] = useState("");
  const [isOthersUg, setIsOthersUg] = useState(false);
  const [isOthersPg, setIsOthersPg] = useState(false);
  const [jobIDs, setJobIDs] = useState([]);
  const [alljobs, setAllJobs] = useState([]);
  const [jobTitle, setJobTitle] = useState([]);
  const [jobDescription, setJobDescription] = useState("");
  const [years, setYears] = useState([]);
  const [resume, setResume] = useState(null);
  const [error, setError] = useState("");
  const [ActiveSkills, setActiveSkills] = useState([]);
  const [requiredSkills, setRequiredSkills] = useState([]);
  const organizationId = window.sessionStorage.getItem("organizationId");
  const [resumeFile, setResumeFile] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [showUploadOverlay, setShowUploadOverlay] = useState(false);

  useEffect(() => {
    getYearsOfExpList();
    getMonthsOfExpList();
    getActiveSkills();
    getUgDetails();
    getPgDetails();
    fetchAllJobs();
    fetchActiveJobs();
  }, []);

  // Prevent tab switching and back button during upload
  useEffect(() => {
    if (!showUploadOverlay) return;

    // Prevent back button
    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = "";
      return "";
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [showUploadOverlay]);

  const handleFormSubmit = async (event) => {
    event.preventDefault();
    try {
      if (!selectedJobID || !selectedJobID.trim()) {
        console.error("JobID cannot be empty");
        Toast.error("JobID cannot be empty");
        return;
      }
      if (!candidate_full_name.trim()) {
        console.error("Candidate name cannot be empty");
        Toast.error("Candidate name cannot be empty");
        return;
      }

      if (!email_id.trim()) {
        console.error("Email cannot be empty");
        Toast.error("Email cannot be empty");
        return;
      }

      if (requiredSkills.length === 0) {
        console.error("Skills cannot be empty");
        Toast.error("Skills cannot be empty");
        return;
      }
      if (!selectedYear.trim()) {
        console.error("Experience of years cannot be empty");
        Toast.error("Experience of years cannot be empty");
        return;
      }
      if (!selectedMonth.trim()) {
        console.error("Experience of months cannot be empty");
        Toast.error("Experience of months cannot be empty");
        return;
      }
      if (!resumeFile) {
        console.error("Resume cannot be empty");
        Toast.error("Resume cannot be empty");
        return;
      }

      console.log(
        "Data is added",
        candidate_full_name,
        email_id,
        requiredSkills,
        selectedYear,
        selectedMonth,
        resumeFile,
        educationDetails
      );

      // Show upload overlay
      setShowUploadOverlay(true);
      setUploadProgress(0);

      // Simulate progress
      const progressInterval = setInterval(() => {
        setUploadProgress((prev) => {
          if (prev >= 90) {
            clearInterval(progressInterval);
            return 90;
          }
          return prev + Math.random() * 15;
        });
      }, 300);

      // Prepare form data for submission
      const formData = new FormData();
      formData.append("organization_id", organizationId);
      formData.append("job_id", selectedJobID);
      formData.append("candidate_full_name", candidate_full_name);
      formData.append("email_id", email_id);
      formData.append("skills", requiredSkills);
      formData.append("experience_years", selectedYear);
      formData.append("experience_months", selectedMonth);
      formData.append("upload_resume", resumeFile);
      formData.append("educational_qualification", educationDetails);
      formData.append("job_description", jobDescription);

      // Log form data
      const formDataObject = {};
      formData.forEach((value, key) => {
        formDataObject[key] = value;
      });

      const response = await aiDishaApi.post("/add-candidate/", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      console.log("Response:", response);
      
      // Clear progress interval
      clearInterval(progressInterval);
      
      // Complete the progress bar
      setUploadProgress(100);

      // Wait a bit to show completion, then hide overlay
      setTimeout(() => {
        if (response.status === 200) {
          Toast.success("Added successfully");
          setShowUploadOverlay(false);
          handleClear();
          setUploadProgress(0);
        }
      }, 1500);
    } catch (error) {
      console.error("Error:", error);
      setShowUploadOverlay(false);
      setUploadProgress(0);
      if (error.response) {
        console.error("Response data:", error.response.data);
        Toast.error(
          error.response.data.detail || "An unexpected error occurred"
        );
      } else {
        Toast.error("An unexpected error occurred");
      }
    }
  };

  // To get all 'active' skills from Skill table
  const getActiveSkills = async () => {
    await aiDishaApi
      .get("/skills-show/active")
      .then((response) => {
        const skillData = response.data;
        setActiveSkills(skillData);
        console.log("checking skills values :", skillData);
        const skillNames = skillData.map((skill) => skill.skill_name);
        console.log("All Skill Names:", skillNames);
      })
      .catch((error) => {
        console.error("Error fetching active skills" + error);
      });
  };

  const fetchAllJobs = async () => {
    try {
      const response = await aiDishaApi.get(
        `/all_active_jobs?org_id=${organizationId}`
      );
      const jobs = response.data;

      if (Array.isArray(jobs)) {
        setAllJobs(jobs);
        console.log("All Jobs: ", jobs);
      } else {
        console.warn("Expected an array but received: ", jobs);
        setAllJobs([]);
      }
    } catch (error) {
      console.error("Error fetching all jobs: ", error);
      setAllJobs([]);
    }
  };

  const fetchActiveJobs = async (jobID) => {
    setSelectedJobID(jobID);

    try {
      const response = await aiDishaApi.get(
        `/get_jobdetail_by_job_id?job_id=${jobID}`
      );
      const jobData = response.data;
      console.log("Job data fetched:", jobData);

      if (jobData) {
        // Set job title
        if (jobData.job_title) {
          setJobTitle(jobData.job_title);
          console.log(`Job Title for ${jobID}: ${jobData.job_title}`);
        } else {
          setJobTitle("");
          console.warn(`No job title found for Job ID: ${jobID}`);
        }

        // Set job description
        if (jobData.job_description) {
          setJobDescription(jobData.job_description);
          console.log(
            `Job Description for ${jobID}: ${jobData.job_description}`
          );
        } else {
          setJobDescription("");
          console.warn(`No job description found for Job ID: ${jobID}`);
        }
      } else {
        setJobTitle("");
        setJobDescription("");
        console.warn(`No job found for Job ID: ${jobID}`);
      }
    } catch (error) {
      console.error(`Error fetching data for Job ID: ${jobID}`, error);
      setJobTitle("");
      setJobDescription("");
    }
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    const maxSize = 5 * 1024 * 1024; // 5MB

    if (file.size > maxSize) {
      Toast.error("File size must be less than 5 MB");
      return;
    }

    setResumeFile(file);
  };

  const removeFile = () => {
    setResumeFile(null);
  };

  const handleClear = () => {
    setSelectedJobDetails("");
    setCandidate_full_name("");
    setSelectedJobID("");
    setEmail_id("");
    setEduDetails([]);
    setJobTitle("");
    setJobDescription("");
    setRequiredSkills([]);
    setSelectedYear("");
    setSelectedMonth("");
    setResumeFile(null);
    setUploadProgress(0);
  };

  const currentDate = moment().format("MM/DD/YYYY");

  const getYearsOfExpList = async () => {
    setYearsOfExpList([
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20",
      "21",
      "22",
      "23",
      "24",
      "25",
      "26",
      "27",
      "28",
      "29",
      "30",
      "31",
      "32",
      "33",
      "34",
      "35",
      "36",
      "37",
      "38",
      "39",
      "40",
    ]);
  };

  const getMonthsOfExpList = async () => {
    setMonthsOfExpList([
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
    ]);
  };

  const getUgDetails = async () => {
    await aiDishaApi
      .get("/undergraduate_degrees")
      .then((response) => {
        setEducationDetailsUg(response.data);
        console.log(response.data);
      })
      .catch((error) => {
        console.error("Error fetching UG details" + error);
      });
  };

  const getPgDetails = async () => {
    await aiDishaApi
      .get("/postgraduate_degrees")
      .then((response) => {
        setEducationDetailsPg(response.data);
        console.log(response.data);
      })
      .catch((error) => {
        console.error("Error fetching PG details" + error);
      });
  };

  const validateEdu = (event) => {};

  const setEduDetails = (event) => {
    console.log(event);
    setEducationDetails(event);

    for (var i = 0; i < event?.length; i++) {
      setIsOthersUg(event[i] == "Others(UG)" ? true : false);
      if (isOthersUg) {
        break;
      }
    }
    for (var i = 0; i < event?.length; i++) {
      setIsOthersUg(event[i] == "Others(UG)" ? true : false);
      if (isOthersUg) {
        break;
      }
    }
    for (var i = 0; i < event?.length; i++) {
      setIsOthersPg(event[i] == "Others(PG)" ? true : false);
      if (isOthersPg) {
        break;
      }
    }
    for (var i = 0; i < event?.length; i++) {
      setIsOthersPg(event[i] == "Others(PG)" ? true : false);
      if (isOthersPg) {
        break;
      }
    }
    console.log("UG others ? " + isOthersUg);
    console.log("PG others ? " + isOthersPg);
  };

  const CssTextField = styled(TextField)({
    "& .MuiPaper-root": {
      backgroundColor: "#033538",
    },
    "& .MuiMenuItem-root": {
      color: "white",
    },
  });

  const CssFormControl = styled(FormControl)({
    "& label": {
      color: "black",
      "&.Mui-focused": {
        color: "black",
      },
    },
    "& .MuiInputBase-root": {
      color: "black",
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#B9B9B9",
        borderRadius: 10,
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "#B9B9B9",
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "#B9B9B9",
      },
    },
  });

  const CssSelect = styled(Select)({
    "& .MuiSvgIcon-root": {
      color: "black",
      textAlign: "center",
    },
  });

  return (
    <>
      {/* Upload Overlay */}
      <UploadOverlay 
        isVisible={showUploadOverlay} 
        progress={uploadProgress} 
        resumeFile={resumeFile}
      />

      <div
        style={{
          height: "calc(100% - 6%)",
          overflow: "scroll",
          overflowX: "hidden",
          scrollbarWidth: "thin",
          msOverflowStyle: "none",
          scrollbarColor: "transparent transparent",
          "&::-webkit-scrollbar": {
            width: "5px",
            height: "5px",
          },
        }}
      >
        <form onSubmit={handleFormSubmit}>
          <Box
            display="grid"
            gridTemplateColumns="repeat(12, 1fr)"
            sx={{
              marginTop: "auto",
              alignItems: "center",
              borderRadius: "10px",
              padding: "1% 10%",
            }}
          >
            <Box
              gridColumn="span 12"
              sx={{ marginTop: "auto", textAlign: "left", marginBottom: "3%" }}
            >
              <Typography
                sx={{ fontFamily: "poppins", fontSize: "28px", color: COLORS.text }}
              >
                Add Candidate
              </Typography>
            </Box>

            <Box
              gridColumn="span 6"
              sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
            >
              <Typography sx={{ fontFamily: "poppins", color: COLORS.text }}>
                Job ID<span style={{ color: "red" }}>*</span>
              </Typography>
              <CssTextField
                select
                displayEmpty
                value={selectedJobID}
                onChange={(e) => fetchActiveJobs(e.target.value)}
                size="small"
                required
                disabled={false}
                sx={{
                  width: "95%",
                  color: COLORS.text,
                  background: COLORS.primary,
                  "& .MuiSelect-select": {
                    color: selectedJobID ? COLORS.text : "#888888",
                  },
                }}
              >
                <MenuItem
                  value=""
                  disabled
                  sx={{
                    color: COLORS.text,
                    background: "white",
                    "&.Mui-disabled": {
                      color: COLORS.text,
                      opacity: 1,
                    },
                  }}
                >
                  Select Job ID
                </MenuItem>

                {alljobs.map((job) => (
                  <MenuItem
                    key={job.Job_ID}
                    value={job.Job_ID}
                    sx={{
                      color: COLORS.text,
                      background: "white",

                      "&:hover": {
                        background: COLORS.border,
                      },

                      "&.Mui-selected": {
                        background: COLORS.border,
                        color: COLORS.text,
                      },

                      "&.Mui-selected:hover": {
                        background: COLORS.border,
                      },
                    }}
                  >
                    {job.Job_ID}
                  </MenuItem>
                ))}
              </CssTextField>
            </Box>

            <Box
              gridColumn="span 6"
              sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
            >
              <Typography sx={{ fontFamily: "poppins", color: COLORS.text }}>
                Job Title
              </Typography>

              <CssTextField
                disabled
                placeholder="Job Title"
                value={jobTitle}
                size="small"
                sx={{
                  width: "95%",
                  background: COLORS.primary,

                  "& .MuiInputBase-input.Mui-disabled": {
                    color: COLORS.text,
                    WebkitTextFillColor: COLORS.text,
                    opacity: 1,
                  },

                  "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline":
                    {
                      borderColor: COLORS.border,
                    },
                }}
                InputLabelProps={{
                  sx: {
                    color: COLORS.text,
                    "&.Mui-disabled": {
                      color: COLORS.text,
                    },
                  },
                }}
              />
            </Box>

            <Box
              gridColumn="span 12"
              sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
            >
              <Typography sx={{ fontFamily: "poppins", color: COLORS.text }}>
                Job Description
              </Typography>
              <CssTextField
                disabled
                value={jobDescription}
                size="small"
                multiline
                rows={4}
                sx={{
                  width: "97.5%",
                  background: COLORS.primary,

                  "& .MuiInputBase-input.Mui-disabled": {
                    color: COLORS.text,
                    WebkitTextFillColor: COLORS.text,
                    opacity: 1,
                  },

                  "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline":
                    {
                      borderColor: COLORS.border,
                    },
                }}
                InputLabelProps={{
                  sx: {
                    color: COLORS.text,
                    "&.Mui-disabled": {
                      color: COLORS.text,
                    },
                  },
                }}
              />
            </Box>

            <Box
              gridColumn="span 6"
              sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
            >
              <Typography sx={{ fontFamily: "poppins", color: COLORS.text }}>
                Candidate_fullname<span style={{ color: "red" }}>*</span>
              </Typography>
              <TextField
                size="small"
                id="custom-css-outlined-input"
                variant="outlined"
                value={candidate_full_name}
                onChange={(e) => setCandidate_full_name(e.target.value)}
                sx={{
                  width: "95%",
                  borderRadius: "10px",
                  background: COLORS.primary,
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: COLORS.border,
                    borderRadius: "10px",
                  },
                  "&.MuiOutlinedInput-root.Mui-focused.MuiOutlinedInput-notchedOutline":
                    {
                      borderColor: COLORS.border,
                      color: COLORS.text,
                    },
                  "& .MuiInputLabel-root": {
                    color: COLORS.text,
                  },
                  "& .MuiInputLabel-root.Mui-focused": {
                    color: COLORS.text,
                  },
                  "& .MuiInputBase-input": {
                    color: COLORS.text,
                  },
                }}
                required
              />
            </Box>

            <Box
              gridColumn="span 6"
              sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
            >
              <Typography sx={{ fontFamily: "poppins", color: COLORS.text }}>
                Email<span style={{ color: "red" }}>*</span>
              </Typography>
              <TextField
                size="small"
                id="custom-css-outlined-input"
                variant="outlined"
                value={email_id}
                onChange={(e) => setEmail_id(e.target.value)}
                sx={{
                  width: "95%",
                  background: COLORS.primary,
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: COLORS.border,
                    borderRadius: "10px",
                  },
                  "&.MuiOutlinedInput-root.Mui-focused.MuiOutlinedInput-notchedOutline":
                    {
                      borderColor: COLORS.border,
                    },
                  "& .MuiInputLabel-root": {
                    color: COLORS.text,
                  },
                  "& .MuiInputLabel-root.Mui-focused": {
                    color: COLORS.text,
                  },
                  "& .MuiInputBase-input": {
                    color: COLORS.text,
                  },
                }}
                required
              />
            </Box>

            <Box
              gridColumn="span 6"
              sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
            >
              <Typography
                sx={{
                  fontFamily: "poppins",
                  color: COLORS.text,
                  textAlign: "left",
                }}
              >
                Skills
                <span style={{ color: "red" }}>*</span>
              </Typography>
              <CssFormControl
                sx={{
                  width: "90%",
                  background: COLORS.primary,
                  borderRadius: "10px",
                  "& .MuiInputLabel-root": {
                    color: COLORS.text,
                  },
                  "& .MuiInputLabel-root.Mui-focused": {
                    color: COLORS.text,
                  },
                }}
              >
                <InputLabel>Select Skills</InputLabel>
                <CssSelect
                  multiple
                  label="Select skills"
                  id="demo-simple-select-outlined"
                  size="small"
                  sx={{
                    width: "100%",
                    textAlign: "center",
                    mb: "2%",
                    borderRadius: "10px",
                    borderColor: COLORS.border,
                    "& .MuiInputBase-input": {
                      color: COLORS.text,
                    },
                  }}
                  value={requiredSkills}
                  onChange={(e) => setRequiredSkills(e.target.value)}
                >
                  {(ActiveSkills || []).map((skill) => (
                    <MenuItem
                      key={skill.skill_id}
                      value={skill.skill_name.trim()}
                      sx={{ color: COLORS.text, backgroundColor: "white" }}
                    >
                      {skill.skill_name.trim()}
                    </MenuItem>
                  ))}
                </CssSelect>
              </CssFormControl>
            </Box>

            <Box
              gridColumn="span 6"
              sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
            >
              <Typography
                sx={{
                  fontFamily: "poppins",
                  color: COLORS.text,
                  textAlign: "left",
                }}
              >
                Experience(in Years)<span style={{ color: "red" }}>*</span>
              </Typography>
              <CssFormControl
                sx={{
                  width: "40%",
                  background: COLORS.primary,
                  borderRadius: "10px",
                  "& .MuiInputBase-input": {
                    color: COLORS.text,
                  },
                  "& .MuiInputLabel-root": {
                    color: COLORS.text,
                  },
                  "& .MuiInputLabel-root.Mui-focused": {
                    color: COLORS.text,
                  },
                }}
              >
                <InputLabel>Select Years</InputLabel>
                <CssSelect
                  label="Experience"
                  id="demo-simple-select-outlined"
                  size="small"
                  value={selectedYear}
                  onChange={(e) => setSelectedYear(e.target.value)}
                  sx={{ width: "100%", textAlign: "center" }}
                  required={true}
                  disabled={false}
                >
                  {yearsOfExpList.map((exp) => (
                    <MenuItem
                      key={exp}
                      value={exp}
                      sx={{ color: COLORS.text, background: "white" }}
                    >
                      {exp}
                    </MenuItem>
                  ))}
                </CssSelect>
              </CssFormControl>
              <CssFormControl
                sx={{
                  width: "40%",
                  ml: "5%",
                  background: COLORS.primary,
                  borderRadius: "10px",
                  "& .MuiInputBase-input": {
                    color: COLORS.text,
                  },
                  "& .MuiInputLabel-root": {
                    color: COLORS.text,
                  },
                  "& .MuiInputLabel-root.Mui-focused": {
                    color: COLORS.text,
                  },
                }}
              >
                <InputLabel>Select Months</InputLabel>
                <CssSelect
                  label="Experience"
                  id="demo-simple-select-outlined"
                  size="small"
                  value={selectedMonth}
                  onChange={(e) => setSelectedMonth(e.target.value)}
                  sx={{ width: "100%", textAlign: "center" }}
                  required={true}
                  disabled={false}
                >
                  {monthsOfExpList.map((exp) => (
                    <MenuItem
                      key={exp}
                      value={exp}
                      sx={{ color: COLORS.text, backgroundColor: "white" }}
                    >
                      {exp}
                    </MenuItem>
                  ))}
                </CssSelect>
              </CssFormControl>
            </Box>

            <Box
              gridColumn="span 6"
              sx={{
                marginTop: "auto",
                textAlign: "left",
                marginBottom: "2%",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "poppins",
                  color: COLORS.text,
                  textAlign: "left",
                }}
              >
                Education<span style={{ color: "red" }}>*</span>
              </Typography>
              <CssFormControl
                sx={{
                  width: "90%",
                  background: COLORS.primary,
                  borderRadius: "10px",
                  "& .MuiInputLabel-root": {
                    color: COLORS.text,
                  },
                  "& .MuiInputLabel-root.Mui-focused": {
                    color: COLORS.text,
                  },
                }}
              >
                <InputLabel>Select Education Details</InputLabel>
                <CssSelect
                  multiple={true}
                  label="Select education details"
                  id="demo-simple-select-outlined"
                  size="small"
                  required
                  sx={{
                    width: "100%",
                    textAlign: "center",
                    mb: "2%",
                    "& .MuiInputBase-input": {
                      color: COLORS.text,
                    },
                  }}
                  value={educationDetails}
                  onChange={(e) => setEduDetails(e.target.value)}
                >
                  <MenuItem
                    key="ug"
                    value="ug"
                    disabled={true}
                    sx={{ color: "#B9B9B9", backgroundColor: "black" }}
                  >
                    Under Graduate
                  </MenuItem>
                  {educationDetailsUg.map((degreeUg) => (
                    <MenuItem
                      key={degreeUg}
                      value={degreeUg}
                      sx={{ color: COLORS.text, backgroundColor: "white" }}
                    >
                      {degreeUg}
                    </MenuItem>
                  ))}
                  <MenuItem
                    key="pg"
                    value="pg"
                    disabled={true}
                    sx={{ color: "#B9B9B9", backgroundColor: "black" }}
                  >
                    Post Graduate
                  </MenuItem>
                  {educationDetailsPg.map((degreePg) => (
                    <MenuItem
                      key={degreePg}
                      value={degreePg}
                      sx={{ color: COLORS.text, backgroundColor: "white" }}
                    >
                      {degreePg}
                    </MenuItem>
                  ))}
                </CssSelect>
              </CssFormControl>
            </Box>

            <Box
              gridColumn="span 6"
              sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
              display={isOthersUg == true ? "block" : "none"}
            >
              <Typography
                sx={{
                  fontFamily: "poppins",
                  color: "#033538",
                  textAlign: "left",
                }}
              >
                Educational Details (UG)
              </Typography>
              <CssTextField
                label="Enter UG Educational Details"
                id="custom-css-outlined-input"
                size="small"
                sx={{ width: "90%", mb: "2%" }}
                value={ugDegree}
                onChange={(e) => setUgDegree(e.target.value)}
              />
            </Box>

            <Box
              gridColumn="span 6"
              sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
              display={isOthersPg == true ? "block" : "none"}
            >
              <Typography
                sx={{
                  fontFamily: "poppins",
                  color: "#033538",
                  textAlign: "left",
                }}
              >
                Educational Details (PG)
              </Typography>
              <CssTextField
                label="Enter PG Educational Details"
                id="custom-css-outlined-input"
                size="small"
                sx={{ width: "90%", mb: "2%" }}
                value={pgDegree}
                onChange={(e) => setPgDegree(e.target.value)}
              />
            </Box>

            <Box
              gridColumn="span 6"
              sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
            >
              <label
                htmlFor="formFile"
                className="form-label"
                style={{ color: COLORS.text }}
              >
                Upload Resume <span style={{ color: "red" }}>*</span>
              </label>

              <input
                className="form-control"
                type="file"
                id="formFile"
                style={{ width: "95%" }}
                accept=".pdf,.doc,.docx"
                onChange={handleFileChange}
              />

              <Typography sx={{ fontSize: "12px", color: "#888", mt: 1 }}>
                Maximum file size: 5 MB
              </Typography>

              {resumeFile && (
                <Box
                  sx={{
                    mt: 1,
                    p: 1,
                    width: "95%",
                    border: "1px solid #ddd",
                    borderRadius: "6px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Typography sx={{ color: COLORS.text, fontSize: "14px" }}>
                    {resumeFile.name} ({(resumeFile.size / 1024 / 1024).toFixed(2)} MB)
                  </Typography>

                  <Button
                    size="small"
                    color="error"
                    onClick={removeFile}
                  >
                    Remove
                  </Button>
                </Box>
              )}
            </Box>

            <Box
              gridColumn="span 8"
              sx={{ marginTop: "8%", ml: "35%", textAlign: "center" }}
            >
              <Button
                onClick={handleClear}
                sx={{
                  border: "1px solid",
                  color: COLORS.button,
                  width: "120px",
                  height: "40px",
                  borderRadius: "10px",
                  fontFamily: "poppins",
                }}
              >
                Reset
              </Button>
              <Button
                type="submit"
                variant="contained"
                disabled={showUploadOverlay}
                sx={{
                  ml: "2%",
                  color: COLORS.button,
                  background: COLORS.button_green_bg,
                  ":hover": {
                    background: COLORS.hover_green_btn,
                  },
                  width: "120px",
                  height: "40px",
                  borderRadius: "10px",
                  fontFamily: "poppins",
                }}
              >
                Submit
              </Button>
            </Box>
          </Box>
        </form>
      </div>
    </>
  );
};

export default AddNewCandidate;